// extracted by mini-css-extract-plugin
export default {"btnCell":"HN8JS2fF4qaqrPh3V0cb"};